<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "border rounded mt-2 p-1" },
    [
      _c("div", { staticClass: "dispute-comments d-inline-block mr-2" }, [
        _vm._v(" " + _vm._s(_vm.$t("feedbback.Dispute-Comments")) + " "),
      ]),
      _c(
        "div",
        {
          ref: "chatBox",
          staticClass: "msg-scrolable-1",
          on: { scroll: _vm.handleScroll },
        },
        _vm._l(_vm.adOrderDisputeComment, function (item, index) {
          return _c("div", { key: index }, [
            _c("div", { staticClass: "mt-1" }, [
              _c(
                "div",
                { staticClass: "d-inline comment-avtar" },
                [
                  _c("b-avatar", {
                    staticClass: "badge-minimal mr-1",
                    attrs: {
                      size: "25",
                      variant: "light-primary",
                      text:
                        item.userName && item.userName.length
                          ? item.userName[0]
                          : "",
                    },
                  }),
                  _c("div", { staticClass: "customer-support d-inline" }, [
                    _vm._v(" " + _vm._s(item.userName) + " "),
                  ]),
                ],
                1
              ),
              item.message
                ? _c("div", { staticClass: "user-message" }, [
                    _vm._v(_vm._s(item.message)),
                  ])
                : _vm._e(),
              _c("div", { staticClass: "last-seen comment-date" }, [
                _vm._v(_vm._s(item.createdTime)),
              ]),
              _c(
                "div",
                [
                  item.docUrl && item.documentType === "image"
                    ? _c("b-img", {
                        staticClass: "image_preview",
                        attrs: { src: item.docUrl },
                        on: {
                          click: function ($event) {
                            return _vm.showImage(true, item.docUrl, "image")
                          },
                        },
                      })
                    : item.docUrl && item.documentType === "video"
                    ? _c("VideoPreview", {
                        attrs: { videoUrl: item.docUrl, documentType: "video" },
                      })
                    : item.docUrl && item.documentType === "pdf"
                    ? _c("PDF", {
                        staticClass: "image_preview_pdf",
                        on: {
                          click: function ($event) {
                            return _vm.showImage(true, item.docUrl, "pdf")
                          },
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]),
          ])
        }),
        0
      ),
      _vm.adOrderDispute.disputeStatus === "UNDER_REVIEW"
        ? _c("div", { staticClass: "mr-1 ml-1 mt-2 pb-1 chat-outer" }, [
            _c("div", { staticClass: "custom-file-outer" }, [
              _c(
                "div",
                { staticClass: "img-input" },
                [
                  _c("b-form-textarea", {
                    ref: "commentTextarea",
                    staticClass: "no-border",
                    attrs: {
                      "max-rows": "1",
                      "no-resize": "",
                      rows: "1",
                      placeholder: _vm.$t("orderCreated.TypeMessage"),
                    },
                    on: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.send($event)
                      },
                    },
                    model: {
                      value: _vm.message,
                      callback: function ($$v) {
                        _vm.message = $$v
                      },
                      expression: "message",
                    },
                  }),
                  _vm.picture && _vm.fileType === "image"
                    ? _c("b-img", {
                        staticStyle: {
                          "max-height": "80px",
                          "max-width": "80px",
                          margin: "3px",
                        },
                        attrs: { src: _vm.picture, alt: "Selected Image" },
                      })
                    : _vm._e(),
                  _vm.picture && _vm.fileType === "video"
                    ? _c("VideoPreview", {
                        attrs: { videoUrl: _vm.picture, documentType: "video" },
                      })
                    : _vm._e(),
                  _vm.picture && _vm.fileType === "pdf"
                    ? _c("PDF", {
                        staticStyle: {
                          "max-height": "80px",
                          "max-width": "80px",
                          margin: "3px",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "send-btn" },
                [
                  _c(
                    "b-link",
                    [
                      _c("Gallery", {
                        staticClass: "mr-1",
                        attrs: { size: "20" },
                        on: { click: _vm.openImagePicker },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-link",
                    [
                      _c("Send", {
                        staticClass: "default-send",
                        class: { primary_send: _vm.message || _vm.imageDocUrl },
                        on: { click: _vm.send },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ])
        : _vm._e(),
      _c("input", {
        ref: "fileInput",
        staticStyle: { display: "none" },
        attrs: { type: "file", accept: "image/*, .pdf,.mkv,video/*" },
        on: { change: _vm.handleHiddenFileInputChange },
      }),
      _c("ImagePreview", {
        attrs: {
          showPop: _vm.showDocumentPreviewModal,
          onModalHidden: _vm.showImage,
          url: _vm.url,
          documentType: _vm.type,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true



//# sourceURL=webpack:///./src/@core/components/dispute/DisputeComment.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

import * as bootstrapvue from 'bootstrap-vue';
import assets_rashi_coin_send_svg from '@/assets/rashi-coin/send.svg';
import assets_rashi_coin_image_svg from '@/assets/rashi-coin/image.svg';
import core_components_toastification_ToastificationContent_vue from '@core/components/toastification/ToastificationContent.vue';
import libs_api_api from '@/libs/api/api';
import layouts_components_ImagePreview_vue from '@/layouts/components/ImagePreview.vue';
import layouts_components_VideoPreview_vue from '@/layouts/components/VideoPreview.vue';
import * as vuex from 'vuex';
import utils_constants from '@/utils/constants';
import moment from 'moment';
import assets_rashi_coin_pdf_icon_svg from '@/assets/rashi-coin/pdf-icon.svg';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












export default ({
  render,
  staticRenderFns,
  components: {
    BImg: bootstrapvue["BImg"],
    BLink: bootstrapvue["BLink"],
    BAvatar: bootstrapvue["BAvatar"],
    Gallery: assets_rashi_coin_image_svg,
    Send: assets_rashi_coin_send_svg,
    ImagePreview: layouts_components_ImagePreview_vue,
    VideoPreview: layouts_components_VideoPreview_vue,
    BFormTextarea: bootstrapvue["BFormTextarea"],
    PDF: assets_rashi_coin_pdf_icon_svg
  },
  props: {
    adOrderDispute: {
      type: Object,
      isRequired: false,
      default: () => {}
    }
  },
  data() {
    return {
      intervalId: null,
      lastFetchTime: null,
      adOrderDisputeComment: [],
      message: "",
      picture: null,
      imageDocUrl: null,
      name: "",
      userLevel: "",
      showDocumentPreviewModal: false,
      url: "",
      type: "",
      page: 1,
      size: 10,
      apiCallTimerFlag: true,
      oldMessage: "",
      oldPicture: "",
      oldImageDocUrl: "",
      fileType: ""
    };
  },
  computed: {
    ...vuex.mapState("user", ["user"])
  },
  watch: {},
  mounted() {
    if (this.adOrderDispute.id) {
      this.getDisputeMessage();
      this.intervalId = setInterval(this.getDisputeMessage, utils_constants["messageInterval"] * 1000);
    }
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
  methods: {
    handleScroll() {
      this.apiCallTimerFlag = true;
      const scrollContainer = this.$refs.chatBox;
      const scrollOffset = scrollContainer.scrollHeight - scrollContainer.scrollTop - 1;
      const containerHeight = scrollContainer.clientHeight;
      if (scrollOffset < containerHeight && this.apiCallTimerFlag) {
        this.page++;
        this.apiCallTimerFlag = false;
        this.getDisputeMessageScroll();
      }
      setTimeout(() => {
        this.apiCallTimerFlag = true;
      }, 800);
    },
    showImage(flag, url, type) {
      this.showDocumentPreviewModal = flag;
      if (flag) {
        this.url = url;
        this.type = type;
      } else {
        this.url = "";
        this.type = "";
      }
    },
    openImagePicker() {
      this.$refs.fileInput.click();
      this.$refs.commentTextarea.focus();
    },
    handleHiddenFileInputChange(event) {
      const file = event.target.files[0];
      if (file) {
        const maxFileSize = utils_constants["sizeLimit"] * 1024 * 1024;
        const maxVideoSize = utils_constants["videoSizeLimit"] * 1024 * 1024;
        if ((file.type.includes("image") || file.type === "application/pdf") && file.size >= maxFileSize) {
          this.$toast({
            component: core_components_toastification_ToastificationContent_vue,
            props: {
              title: this.$t("Errors.UnsupportedFileSize", {
                limit: utils_constants["sizeLimit"]
              }),
              icon: "EditIcon",
              variant: "danger"
            }
          });
          return;
        } else if (file.type.includes("video") && file.size >= maxVideoSize) {
          this.$toast({
            component: core_components_toastification_ToastificationContent_vue,
            props: {
              title: this.$t("Errors.UnsupportedFileSize", {
                limit: utils_constants["videoSizeLimit"]
              }),
              icon: "EditIcon",
              variant: "danger"
            }
          });
          return;
        }
        this.imageDocUrl = null;
        this.picture = "";
        const reader = new FileReader();
        reader.onload = e => {
          if (file.type.includes("video")) {
            this.fileType = "video";
          } else if (file.type.includes("image")) {
            this.fileType = "image";
          } else if (file.type === "application/pdf") {
            this.fileType = "pdf";
          } else {
            this.$toast({
              component: core_components_toastification_ToastificationContent_vue,
              props: {
                title: this.$t("Errors.UnsupportedFileType"),
                icon: "EditIcon",
                variant: "danger"
              }
            });
            return;
          }
          this.imageDocUrl = file;
          this.picture = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    dateFormat(dateTime) {
      if (!dateTime) return "";
      const str = String(dateTime);
      if (moment(str, moment.ISO_8601, true).isValid()) {
        return moment(str).format("YYYY-MM-DD HH:mm");
      }
      const withZ = (str.endsWith("Z") || str.includes("+")) ? str : `${str}Z`;
      if (moment(withZ, moment.ISO_8601, true).isValid()) {
        return moment(withZ).format("YYYY-MM-DD HH:mm");
      }
      if (moment(dateTime).isValid()) {
        return moment(dateTime).format("YYYY-MM-DD HH:mm");
      }
      return "";
    },
    clearData() {
      this.oldMessage = this.message;
      this.oldPicture = this.picture;
      this.oldImageDocUrl = this.imageDocUrl;
      this.message = "";
      this.picture = null;
      this.imageDocUrl = null;
    },
    async send() {
      try {
        this.message = this.message.trim();
        if (this.message || this.imageDocUrl) {
          const formData = new FormData();
          this.adOrderDispute.id && formData.append("orderDisputeId", this.adOrderDispute.id);
          this.message && formData.append("message", this.message);
          this.imageDocUrl && formData.append("imageDocUrl", this.imageDocUrl);
          const res = await new libs_api_api().api({
            method: "post",
            url: "p2p/dispute/comment"
          }, formData, {});
          this.clearData();
          if (res && res.result && res.result.requestStatus == "SUCCESS") {
            await this.getDisputeMessage(true);
          } else if (res && res.error && res.error.message) {
            this.message = this.oldMessage;
            this.picture = this.oldPicture;
            this.imageDocUrl = this.oldImageDocUrl;
            this.$toast({
              component: core_components_toastification_ToastificationContent_vue,
              props: {
                title: res.error.message,
                icon: "EditIcon",
                variant: "danger"
              }
            });
          }
        }
      } catch (error) {
        this.$toast({
          component: core_components_toastification_ToastificationContent_vue,
          props: {
            title: error,
            icon: "EditIcon",
            variant: "danger"
          }
        });
      }
    },
    scrollToBottom() {
      this.$nextTick(function () {
        setTimeout(() => {
          var container = this.$refs.chatBox;
          container.scrollTo({
            top: 0,
            behavior: "smooth"
          });
        }, 10);
      });
    },
    async getDisputeMessage(userMessage) {
      try {
        if (this.adOrderDispute.id) {
          const res = await new libs_api_api().api({
            method: "GET",
            url: `p2p/dispute/comments/${this.adOrderDispute.id}`
          }, {
            lastFetchTime: this.lastFetchTime || undefined
          }, {});
          if (res && res.adOrderDisputeComment && res.adOrderDisputeComment.length) {
            let adOrderDisputeComment = [];
            for (let i = res.adOrderDisputeComment.length - 1; i >= 0; i--) {
              adOrderDisputeComment.push({
                ...res.adOrderDisputeComment[i],
                createdTime: this.dateFormat(res.adOrderDisputeComment[i].createdTime),
                documentType: res.adOrderDisputeComment[i].docUrl ? utils_constants.getFileType(res.adOrderDisputeComment[i].docUrl) : ""
              });
            }
            this.adOrderDisputeComment = adOrderDisputeComment.concat(this.adOrderDisputeComment);
            if (res.adOrderDisputeComment.length) {
              this.lastFetchTime = res.adOrderDisputeComment[res.adOrderDisputeComment.length - 1].createdTime;
            } else {
              this.lastFetchTime = new Date().toISOString().split("Z")[0];
            }
          } else if (res && res.error && res.error.message) {
            this.$toast({
              component: core_components_toastification_ToastificationContent_vue,
              props: {
                title: res.error.message,
                icon: "EditIcon",
                variant: "danger"
              }
            });
          }
        }
      } catch (error) {
        this.$toast({
          component: core_components_toastification_ToastificationContent_vue,
          props: {
            title: error,
            icon: "EditIcon",
            variant: "danger"
          }
        });
      }
    },
    async getDisputeMessageScroll() {
      try {
        if (this.adOrderDispute.id) {
          const res = await new libs_api_api().api({
            method: "GET",
            url: `p2p/dispute/comments/${this.adOrderDispute.id}`
          }, {
            page: this.page,
            size: this.size
          }, {});
          if (res && res.adOrderDisputeComment && res.adOrderDisputeComment.length) {
            let adOrderDisputeComment = [];
            for (let i = res.adOrderDisputeComment.length - 1; i >= 0; i--) {
              adOrderDisputeComment.push({
                ...res.adOrderDisputeComment[i],
                createdTime: this.dateFormat(res.adOrderDisputeComment[i].createdTime),
                documentType: res.adOrderDisputeComment[i].docUrl ? utils_constants.getFileType(res.adOrderDisputeComment[i].docUrl) : ""
              });
            }
            this.adOrderDisputeComment = this.adOrderDisputeComment.concat(adOrderDisputeComment);
          } else if (res && res.error && res.error.message) {
            this.$toast({
              component: core_components_toastification_ToastificationContent_vue,
              props: {
                title: res.error.message,
                icon: "EditIcon",
                variant: "danger"
              }
            });
          }
        }
      } catch (error) {
        this.$toast({
          component: core_components_toastification_ToastificationContent_vue,
          props: {
            title: error,
            icon: "EditIcon",
            variant: "danger"
          }
        });
      }
    }
  }
});

//# sourceURL=webpack:///./src/@core/components/dispute/DisputeComment.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

<style scoped>
.dispute-comments {
  color: var(--text-black-color);
  font-size: 19px;
  font-weight: 600;
  line-height: 24px;
}
.customer-support {
  color: #48515d;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
}
[dir=ltr] .customer-support {
  margin-left: 5px;
}
[dir=rtl] .customer-support {
  margin-right: 5px;
}
.last-seen {
  font-size: 13px;
}
[dir] .last-seen {
  margin-bottom: 5px;
}
.primary_send {
  opacity: 1;
path {
    fill: #8dc540;
    stroke: #8dc540;
}
}
.image_preview {
  max-height: 200px;
  max-width: 100%;
}
.msg-scrolable-1 {
  max-height: 200px;
  overflow-y: auto;
}

.custom-file-outer .upload-img-pick {
  max-width: calc(100% - 60%);
}
</style>
